export type SmsEncoding = 'GSM-7' | 'UCS-2';

export type SmsMetrics = {
  characters: number;
  units: number;
  segments: number;
  encoding: SmsEncoding;
  per_segment: number;
};

const GSM_BASIC = new Set(Array.from(
  '@\u00a3$\u00a5\u00e8\u00e9\u00f9\u00ec\u00f2\u00c7\n\u00d8\u00f8\r\u00c5\u00e5\u0394_\u03a6\u0393\u039b\u03a9\u03a0\u03a8\u03a3\u0398\u039e\u001b\u00c6\u00e6\u00df\u00c9 !"#\u00a4%&\'()*+,-./0123456789:;<=>?\u00a1ABCDEFGHIJKLMNOPQRSTUVWXYZ\u00c4\u00d6\u00d1\u00dc\u00a7\u00bfabcdefghijklmnopqrstuvwxyz\u00e4\u00f6\u00f1\u00fc\u00e0'
));
const GSM_EXTENDED = new Set(Array.from('^{}\\[~]|\u20ac'));

export function normalizeNzMobile(value: string | null | undefined): string | null {
  if (!value) return null;
  let compact = value.trim().replace(/[\s().-]/g, '');
  if (compact.startsWith('+')) compact = compact.slice(1);
  if (compact.startsWith('0064')) compact = compact.slice(2);
  if (/^02\d{7,9}$/.test(compact)) compact = `64${compact.slice(1)}`;
  return /^642\d{7,9}$/.test(compact) ? compact : null;
}

export function smsMetrics(value: string): SmsMetrics {
  const characters = Array.from(value).length;
  let gsmUnits = 0;
  let gsm = true;
  for (const character of Array.from(value)) {
    if (GSM_BASIC.has(character)) gsmUnits += 1;
    else if (GSM_EXTENDED.has(character)) gsmUnits += 2;
    else { gsm = false; break; }
  }
  const units = gsm ? gsmUnits : characters;
  const single = gsm ? 160 : 70;
  const multipart = gsm ? 153 : 67;
  return {
    characters,
    units,
    segments: units === 0 ? 0 : units <= single ? 1 : Math.ceil(units / multipart),
    encoding: gsm ? 'GSM-7' : 'UCS-2',
    per_segment: units <= single ? single : multipart
  };
}
